import firebase from "firebase/app";
import "firebase/auth";
import firebaseConfig from "../../firebaseconfig.json";

export const firebaseInstance = firebase.initializeApp(firebaseConfig);
